/**
 * Determines the payment icon based on the payment method title or gateway.
 * Handles both documented Happy API gateways and legacy title-based lookup.
 */
export function getPaymentIconByTitle(
  title: string,
  gateway?: string
): string {
  const lower = (gateway || title || '').toLowerCase();

  if (lower.includes('stripe') || lower.includes('card') || lower.includes('credit')) {
    return 'icon-credit-card-outline';
  }

  if (lower.includes('paypal')) {
    return 'icon-paypal';
  }

  if (lower.includes('authorize')) {
    return 'icon-credit-card-outline';
  }

  if (lower.includes('cash')) {
    return 'icon-banknote';
  }

  if (lower.includes('check')) {
    return 'icon-check-payment';
  }

  return 'icon-banknote-outline';
}

